import React, { useRef, useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

const RiskGaugeChart = ({
  value,
  showTittle = true,
  bgColor = "#fff",
  maxValue = 3,
}) => {
  const chartRef = useRef();
  const [gradientColor, setGradientColor] = useState("#9ACD32");

  const score = Math.min(value || 0, maxValue);
  const percentage = score / maxValue;

  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;

    const ctx = chart.ctx;
    const gradient = ctx.createLinearGradient(0, 0, chart.width, 0);

    gradient.addColorStop(0, "#9ACD32"); // Green
    gradient.addColorStop(0.5, "#FFEB3B"); // Yellow
    gradient.addColorStop(1, "#F44336"); // Red

    setGradientColor(gradient);
  }, [chartRef.current]);

  const data = {
    datasets: [
      {
        data: [percentage, 1 - percentage],
        backgroundColor: [gradientColor, "#eee"],
        borderWidth: 2,
        cutout: "70%",
        rotation: -90,
        circumference: 180,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { enabled: false },
    },
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width={300}
    >
      {showTittle && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Risk Adjustment Factor
        </Typography>
      )}

      <Box
        position="relative"
        width={300}
        height={150}
        sx={{
          backgroundColor: bgColor,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Doughnut data={data} options={options} ref={chartRef} />

        {/* Center Score */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{
            transform: "translate(-50%, -30%)",
            zIndex: 2,
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            {score.toFixed(2)}
          </Typography>
        </Box>

        <Typography
          sx={{
            position: "absolute",
            left: 20,
            bottom: 0,
            fontWeight: 500,
            color: value > 0 ? "white" : "#555",
          }}
        >
          0
        </Typography>
        <Typography
          sx={{
            position: "absolute",
            right: 20,
            bottom: 0,
            fontWeight: 500,
            color: value >= maxValue ? "white" : "#555",
          }}
        >
          {maxValue}
        </Typography>
      </Box>
    </Box>
  );
};

export default RiskGaugeChart;
